<template>
    <footer>
        <img src="@/assets/mik_logo.svg" alt="">
        <button type="button" class="footer_link" @click="$emit('open_harassment')">
            採用選考におけるハラスメント相談窓口
        </button>
        <div>created MIK,inc</div>
    </footer>
</template>

<script>
export default {
    emits: ['open_harassment'],
}</script>

<style>
footer {

    height: 150px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.footer_link {
    background: none;
    border: none;
    color: #3d5a73;
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
    margin: 12px 0 8px;
    padding: 4px;
    font-family: inherit;
}

.footer_link:hover {
    color: #0890a8;
}

footer img {
    width: 150px;
    height: auto;
    object-fit: scale-down;

}
</style>